import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { formatCurrency } from '../../../utils/formatCurrency'
import fuelReportDetailsColumns from './fuelReportDetailsColumns'
import { useNavigate } from 'react-router-dom'
import type { FuelReportDetails } from '../../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../../utils/formatNumber'

type FuelReportDetailsTableProps = {
  data: any
  isLoading?: boolean
  options: { year: string; month: string }
}

function FuelReportDetailsTable({ data, isLoading, options }: FuelReportDetailsTableProps) {
  const columns = fuelReportDetailsColumns({ options })

  return (
    <GenericTable
      className="max-h-[50vh]"
      data={data}
      columns={columns}
      isLoading={isLoading}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} options={options} />
      }}
    />
  )
}

export default FuelReportDetailsTable

function MobileCardContent({
  row,
  options,
}: {
  row: Row<FuelReportDetails>
  options: { year: string; month: string }
}) {
  const navigate = useNavigate()
  const { month, year } = options
  const { amountincVAT, volume, carDescription, invoiceGroupingDescription, accountNo, regNo, vehicleID, driverName } =
    row.original

  const header = regNo || vehicleID
  const data = [
    {
      label: 'Objekt',
      value: carDescription || '',
    },
    {
      label: 'Fakturagruppe',
      value: invoiceGroupingDescription || '',
    },
    {
      label: 'Beløp',
      value: formatCurrency(amountincVAT),
    },
    {
      label: 'Kjøretøy-ID',
      value: vehicleID || '',
    },
    {
      label: 'Sjåfør',
      value: driverName || '',
    },
    {
      label: 'Volum',
      value: formatNumber(volume, { digits: { min: 0, max: 0 } }),
    },
  ]

  const action = {
    onClick: () => {
      navigate(`/reports/fuel/${year}-${month}/${accountNo}?regNo=${regNo}`)
    },
  }

  return <TableMobileCardContent header={header} data={data} action={action} />
}
